import { TPlainTextKey } from '../../../../../../../../../Translations';
import { ClientExperienceResource } from '../../../../Types';

// One button per course category. Offering types that share a label share a button
// (msuite is On-Demand), and any type without a label falls under Other, so the UI never
// shows a raw offering_type and the keys are stable kebab-case slugs.
export type QuickAddCategory =
  | 'coaching'
  | 'professor-led'
  | 'on-demand'
  | 'group-coaching'
  | 'other';

export type QuickAddGroup =
  | { kind: 'all'; key: 'all'; courseIds: number[] }
  | { kind: 'category'; key: QuickAddCategory; courseIds: number[] };

const CATEGORY_ORDER: QuickAddCategory[] = [
  'coaching',
  'professor-led',
  'on-demand',
  'group-coaching',
  'other',
];

const categoryOf = (offeringType: string): QuickAddCategory => {
  switch ((offeringType || '').toLowerCase()) {
    case 'coaching':
      return 'coaching';
    case 'epc':
      return 'professor-led';
    case 'aep':
    case 'msuite':
      return 'on-demand';
    case 'group-coaching':
      return 'group-coaching';
    default:
      return 'other';
  }
};

export const categoryLabel = (category: QuickAddCategory): TPlainTextKey => {
  switch (category) {
    case 'coaching':
      return 'Leadership Coaching';
    case 'professor-led':
      return 'Professor-Led';
    case 'on-demand':
      return 'On-Demand';
    case 'group-coaching':
      return 'Group Coaching';
    case 'other':
      return 'Other';
  }
};

// All first, then one group per category in the current view, so the category counts
// sum to the list count. An empty view has no groups.
export const quickAddGroups = (experiences: ClientExperienceResource[]): QuickAddGroup[] => {
  const categoryGroups: QuickAddGroup[] = CATEGORY_ORDER.map((category) => ({
    kind: 'category' as const,
    key: category,
    courseIds: experiences
      .filter((exp) => categoryOf(exp.payload.offering_type) === category)
      .map((exp) => exp.payload.id),
  })).filter((group) => group.courseIds.length > 0);

  return experiences.length === 0
    ? []
    : [
        { kind: 'all', key: 'all', courseIds: experiences.map((exp) => exp.payload.id) },
        ...categoryGroups,
      ];
};
